import React, { useState, useRef, useEffect } from 'react'
import { useTheme, BACKGROUND_TYPES } from '../../contexts/ThemeContext'

const ThemeDropdown = () => {
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef(null)
  const { backgroundType, setBackgroundType } = useTheme()

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const backgroundOptions = [
    { key: BACKGROUND_TYPES.GLASS, name: 'Glass', emoji: '🌟' },
    { key: BACKGROUND_TYPES.BALLS, name: 'Floating Balls', emoji: '⚪' },
    { key: BACKGROUND_TYPES.LINES, name: 'Animated Lines', emoji: '🌈' }
  ]

  const getCurrentDisplay = () => {
    const option = backgroundOptions.find(t => t.key === backgroundType)
    return option?.emoji || '🌟'
  }

  return (
    <div className="relative" ref={dropdownRef}>
      {/* Dropdown Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between px-4 py-3 bg-black/30 backdrop-blur-xl border border-white/20 rounded-xl hover:bg-black/40 transition-all duration-200"
        title="Change Background Type"
      >
        <div className="flex items-center gap-2">
          <span className="text-lg">{getCurrentDisplay()}</span>
          <span className="text-white font-medium">{backgroundOptions.find(t => t.key === backgroundType)?.name}</span>
        </div>
        <svg
          className={`w-4 h-4 text-white transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {/* Dropdown Menu */}
      {isOpen && (
        <div className="absolute top-full left-0 right-0 mt-2 bg-black/50 backdrop-blur-2xl border border-white/30 rounded-xl shadow-2xl z-50">
          <div className="p-3 space-y-2">
            {backgroundOptions.map((option) => (
              <button
                key={option.key}
                onClick={() => {
                  setBackgroundType(option.key)
                  setIsOpen(false)
                }}
                className={`w-full p-3 rounded-lg text-sm font-medium transition-all duration-200 flex items-center gap-3 ${
                  backgroundType === option.key
                    ? 'bg-purple-600 text-white'
                    : 'bg-white/10 text-gray-300 hover:bg-white/20'
                }`}
              >
                <span className="text-lg">{option.emoji}</span>
                <span>{option.name}</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default ThemeDropdown
